import { apiEndpoints } from '../api/endpoints';

export const startBatchStepsPolling = (sessionId, {
  setIsPolling,
  setTestStatus,
  setScreenshots,
  setError,
  pollIntervalRef
}) => {
  if (pollIntervalRef.current) {
    clearInterval(pollIntervalRef.current);
    pollIntervalRef.current = null;
  }
  
  setIsPolling(true);
  setScreenshots([]);

  // Track the latest step number to determine when a new step starts
  let currentStepIndex = 0;
  // Store the last screenshot URL to avoid duplicates
  let lastScreenshotData = null;
  
  pollIntervalRef.current = setInterval(async () => {
    try {
      const result = await apiEndpoints.getBatchStepsResult(sessionId);
      
      // Immediately stop polling and clear everything if failed
      if (result.status === 'failed') {
        clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
        setIsPolling(false);
        setTestStatus({
          status: 'failed',
          description: result.error || 'Steps failed'
        });
        return;
      }
      
      // Stop polling if status is completed or error
      const { status, screenshot, current_step } = result;

      if (status === 'completed' || status === 'error' || status === 'failed') {
        clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
        setIsPolling(false);

        setTestStatus({
          status,
          description: status === 'error' ? result.error || 'Steps failed' : 'All steps completed successfully'
        });

        if (screenshot?.data) {
          // If the screenshot data is different from last one, add it
          const screenshotData = `data:image/jpeg;base64,${screenshot.data}`;
          if (screenshotData !== lastScreenshotData) {
            setScreenshots(prev => [...prev, screenshotData]);
            lastScreenshotData = screenshotData;
          }
        }

        if (status === 'completed') {
          setTestStatus('success');
        }
        return;
      }

      if (status === 'running') {
        if (screenshot?.data) {
          const screenshotData = `data:image/jpeg;base64,${screenshot.data}`;
          
          // Check if we've moved to a new step (if current_step is available)
          if (current_step && current_step !== currentStepIndex) {
            // We've moved to a new step, always add the screenshot
            setScreenshots(prev => [...prev, screenshotData]);
            lastScreenshotData = screenshotData;
            currentStepIndex = current_step;
          } 
          // If it's the same step but a different screenshot, update it
          else if (screenshotData !== lastScreenshotData) {
            // Check if it's the same step but a different screenshot
            setScreenshots(prev => [...prev, screenshotData]);
            lastScreenshotData = screenshotData;
          }
          // Otherwise it's the same screenshot for the same step, do nothing
        }
      }

    } catch (error) {
      clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = null;
      setIsPolling(false);
      setError('Failed to get batch steps result: ' + error.message);
    }
  }, 3000);
};

export const handleResetScreenshot = async (suiteId, {
  pollIntervalRef,
  setIsPolling,
  setTestStatus,
  setSessionId,
  setInitialScreenshot,
  setScreenshots,
  setError
}) => {
  try {
    // Clear any existing polling first
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = null;
    }
    setIsPolling(false);
    setTestStatus(null);
    
    const result = await apiEndpoints.startBrowserSession(suiteId);
    
    // Set the session ID
    setSessionId(result.sessionId);
    
    // Set initial screenshot if available
    if (result.screenshot?.data) {
      setInitialScreenshot(`data:image/jpeg;base64,${result.screenshot.data}`);
      setScreenshots([])
    }

  } catch (error) {
    console.error('Failed to reset browser session:', error);
    setError('Failed to reset browser session: ' + error.message);
  }
}; 